/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { UserControllerRemoveMutationResponse, UserControllerRemovePathParams, UserControllerRemoveQueryParams, UserControllerRemove400, UserControllerRemove401, UserControllerRemove403, UserControllerRemove404 } from "../../models/usersController/UserControllerRemove";

function getUserControllerRemoveUrl(userId: UserControllerRemovePathParams["userId"]) {
  const res = { method: 'DELETE', url: `/api/v1/users/${userId}` as const }  
  return res
}

/**
 * @description If scope_type is ORGANIZATION and scope_id is provided, removes the user from that organization only. If the user has no remaining org memberships after removal, performs a full soft-delete. Otherwise, removes the user system-wide.
 * @summary Remove a user from a scope or system-wide
 * {@link /api/v1/users/:userId}
 */
export async function userControllerRemove(userId: UserControllerRemovePathParams["userId"], params: UserControllerRemoveQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<UserControllerRemoveMutationResponse, ResponseErrorConfig<UserControllerRemove400 | UserControllerRemove401 | UserControllerRemove403 | UserControllerRemove404>, unknown>({ method : "DELETE", url : getUserControllerRemoveUrl(userId).url.toString(), params, ... requestConfig })  
  return res.data
}